<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">Edit CAPA request</div>
							<!--Header-->
							<div class="page_main">
								<div class="training-cert-page">
									<div class="btn_el">
										<div class="tips">Please provide the complete information for the new request and submit it for review.</div>
									</div>
									<!--表单-->
									<el-form ref="form" :model="form" :rules="rules" label-position="top"
										class="training-form">
										<!-- Description of the issue, concern, idea, or opportunity -->
										<el-form-item label="Description of the issue, concern, idea, or opportunity" prop="description">
											<el-input type="textarea" :rows="3" v-model="form.description"
												placeholder="Please enter" maxlength="" clearable />
										</el-form-item>
										<!-- <el-form-item label="Company" prop="company_id">
											<div class="dept-row">
												<el-select v-model="form.company_id" placeholder="Please select a company"
													class="full-width" style="width: 100%"
													@change="getDepartment(form.company_id)">
													<el-option v-for="value in companyList" :key="value.id"
														:label="value.company_name" :value="value.id"></el-option>
												</el-select>
											</div>
										</el-form-item> -->
										<el-form-item label="Department" prop="departments_id">
											<div class="dept-row">
												<el-select v-model="form.departments_id" placeholder="Please select a department"
													class="full-width" style="width: 100%">
													<el-option v-for="value in departmentsList" :key="value.id"
														:label="value.departments_name" :value="value.id"></el-option>
												</el-select>
											</div>
										</el-form-item>
										<!-- Source Type -->
										<el-form-item label="Source Type" prop="source_type">
											<el-select v-model="form.source_type" placeholder="Please select" style="width: 100%">
												<el-option label="Calibration" value="Calibration" />
												<el-option label="Change Request" value="Change Request" />
												<el-option label="Clinical" value="Clinical" />
												<el-option label="Complaint" value="Complaint" />
												<el-option label="Design Control" value="Design Control" />
												<el-option label="Environmental" value="Environmental" />
												<el-option label="External Audit" value="External Audit" />
												<el-option label="Improvement Opportunity" value="Improvement Opportunity" />
												<el-option label="Internal Audit" value="Internal Audit" />
												<el-option label="Issue" value="Issue" />
												<el-option label="Maintenance" value="Maintenance" />
												<el-option label="Management Review" value="Management Review" />
												<el-option label="Nonconforming Material" value="Nonconforming Material" />
												<el-option label="Supplier Audit" value="Supplier Audit" />
												<el-option label="Other" value="Other" />
											</el-select>
										</el-form-item>
										<!-- Source Information -->
										<el-form-item label="Source Information" prop="source_info">
											<el-input v-model="form.source_info" placeholder="Please enter" maxlength=""
												clearable />
										</el-form-item>
									</el-form>
									<!-- CAPABackground Files -->
									<div class="btn_el">
										<div class="tips">
											Please attach any files containing  CAPA request background information.
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">CAPABackground Files</div>
										</div>
										<el-table ref="fileTable" :data="tableData1" border empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="name" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Action" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove1(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAddCAPAFile">
												Add CAPA Background File
											</el-button>
										</div>
									</div>
									<br />
									<!--Affected Items-->
									<div class="btn_el">
										<div class="tips">
											Add any items affected by the issue, concern, idea, or opportunity (e.g., documents, parts, tools, equipment, etc.).
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">
												Items affected by the issue, concern, idea, or opportunity
											</div>
										</div>
										<el-table ref="fileTable" :data="tableData2" border empty-text="No Data">
											<el-table-column prop="" label="Item Type" min-width="130" sortable>
												<template #default="scope">
													<div v-if="scope.row.article_type == 1">Document</div>
													<div v-if="scope.row.article_type == 2">Equipment</div>
													<div v-if="scope.row.article_type == 3">Product</div>
													<div v-if="scope.row.article_type == 4">Tool</div>
													<div v-if="scope.row.article_type == 5">Other</div>
												</template>
											</el-table-column>
											<el-table-column prop="article_id" label="Item ID" min-width="110" sortable />
											<el-table-column prop="article_name" label="Item Name" min-width="130" sortable />
											<el-table-column prop="article_revision" label="Item Revision" min-width="140" sortable></el-table-column>
											<el-table-column prop="" label="Product Serial Number" min-width="200" sortable>
												<template #default="scope">
													{{ scope.row.serial_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Lot Number" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.lot_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Purchased Product？" min-width="180" sortable>
												<template #default="scope">
													<div v-if="scope.row.is_buy == 1">Yes</div>
													<div v-if="scope.row.is_buy == 2">No</div>
													<div v-else></div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Supplier" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.supplier_name || '' }}
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Action" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove2(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAffectedArticle">
												Add Affected Item
											</el-button>
										</div>
									</div>
									<br />
									<!--Correction-->
									<div class="btn_el">
										<div class="tips">
											Record as Containment/Actions taken to eliminate the detected nonconformity.
										</div>
									</div>
									<div class="card-block">
										<div class="section-header">
											<div class="section-title">Correction</div>
										</div>
										<el-table ref="fileTable" :data="tableData3" border empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Action" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove3(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<div class="file-action-row">
											<el-button size="small" type="primary" @click="handleAddCorrection">
												Add Correction
											</el-button>
										</div>
									</div>
									<div class="footer-actions">
										<el-button type="primary" @click="handleSaveDraft('form')">
											Save
										</el-button>
										<el-button @click="handleCancel"> Cancel </el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--添加文件弹窗-->
		<el-dialog :title="dialogVisibleTitle" :visible.sync="dialogVisible" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form ref="ruleForm" :model="ruleForm" :rules="rules1" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description">
							<el-input v-model="ruleForm.description" type="textarea" :rows="5" resize="none"
								placeholder="Please enter a description" />
						</el-form-item>
						<!-- Attachment -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span> Files to Upload </span>
									<span class="upload-limit"> （Maximum 10 MB） </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/"
										name="files"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange"
										:limit="1"
										:with-credentials="true"
										:auto-upload="false"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No file selected" }}
										<span v-if="fileName" style="position: absolute; right: 20px; top: 12px; cursor: pointer;color: #f00;" @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--添加文件弹窗-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	capaSubmit,
	capaUploadsCapaBackgroundFile,
	capaUploadsCapaBackgroundFileDel,
	capaUploadsCapaCorrectionsFile,
	capaUploadsCapaCorrectionsFileDel,
	capaUploadsCapaAffectedArticleDel
} from "@/api/capaManage/capaRequest/index";
import { capaRequestDetail } from "@/api/capaManage/capaSearch/index"
// import { companyList } from "@/api/system/company";
import { departmentsList } from "@/api/system/department";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from "moment";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			dialogVisibleTitle: "",
			dialogVisible: false,
			fileName: "",
			selectedFile: null,
			form: {
				id: '',
				flow_type: "capa",
				description: "",
				// company_id: "",
				departments_id: "",
				source_type: "",
				source_info: "",
			},
			rules: {
				description: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
				// company_id: [{
				// 	required: true,
				// 	message: "Please select",
				// 	trigger: "change"
				// }],
				departments_id: [{
					required: true,
					message: "Please select",
					trigger: "change"
				}, ],
				source_type: [{
					required: true,
					message: "Please select",
					trigger: "change"
				}],
				source_info: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
			},
			tableData1: [],
			tableData2: [],
			tableData3: [],
			// companyList: [],
			departmentsList: [],
			userToken: localStorage.getItem("userToken"),
			ruleForm: {
				capa_id: "",
				description: "",
				files: ""
			},
			rules1: {
				description: [{
					required: true,
					message: "Please enter comments",
					trigger: "blur"
				}, ],
			},
			ruleForm1: {
				remark: "",
				signature: "",
			},
			rules2: {
				signature: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
			},
			oid: null,
			step: null
		};
	},
	created() {
		let that = this;
		that.oid = that.$route.query.oid;
		that.step = that.$route.query.step;
	},
	mounted() {
		let that = this;
		//Request Company List
		// companyList({
		// 	page: 1,
		// 	page_size: 9999,
		// 	status: 1,
		// 	company_name: "",
		// 	company_userid: "",
		// 	manage_userid: "",
		// }).then((res2) => {
		// 	if(res2.code == 200) {
		// 		that.companyList = res2.data.data;
		// 		//Request Details
		// 		if(that.oid) {
		// 			that.getPageInfo();
		// 		}
		// 	}
		// });
		//Request Details
		if(that.oid) {
			that.getPageInfo();
		}
		that.isLoading = false;
	},
	methods: {
		//Request Page Details
		getPageInfo() {
			let that = this;
			capaRequestDetail({ id: that.oid,page:1,page_size:10 }).then(res => {
				if(res.code == 200) {
					that.form.id = res.data.id;
					that.form.description = res.data.description;
					// that.form.company_id = res.data.company_id;
					that.form.source_type = res.data.source_type;
					that.form.source_info = res.data.source_info;
					that.getDepartment(res.data.departments_id);  //Populate Department
					//Populate CAPA Background Files
					that.tableData1 = res.data.capabackground_list;
					//Populate Correction Files
					that.tableData3 = res.data.capacorrections_list;
					//Populate Affected Items
					that.tableData2 = res.data.capaarticle_list;
				}
			});
		},
		//Timestamp Conversion
		initTime(value) {
			if (value) {
				return moment(value * 1000).format("YYYY-MM-DD");
			}
		},
		//Request Department List
		getDepartment(val) {
			let that = this;
			that.form.departments_id = "";
			that.departmentsList = [];
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
			departmentsList({
				page: 1,
				page_size: 9999,
				status: 1,
				departments_name: "",
				// company_id: value,
				departments_userid: "",
			}).then((res2) => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if (val) {
					that.form.departments_id = Number(val);
				}
			});
		},
		// Add CAPA Background File
		handleAddCAPAFile() {
			let that = this;
			if(that.form.id) {
				that.openFileDialog("Add CAPA Background File");
			}else {
				that.$message.warning("Please create the  CAPA request");
			}
		},
		// Add Correction文件
		handleAddCorrection() {
			let that = this;
			if(that.form.id) {
				that.openFileDialog("Add Correction File");
			}else {
				that.$message.warning("Please create the  CAPA request");
			}
		},
		handleAffectedArticle() {
			let that = this;
			if(that.form.id) {
				that.$router.push({ path: '/CapaControl/addAffectedArticles', query: { oid: that.oid } });
			}else {
				that.$message.warning("Please create the  CAPA request");
			}
		},
		handleAvatarChange(file, fileList) {
			let that = this;
			if (!file && !fileList) return;
			that.selectedFile = file.raw;
			that.fileName = file.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if (!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed  10 MB");
				return false;
			}
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
		},
		//Save
		handleSaveDraft(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					capaSubmit(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				} else {
					return false;
				}
			});
		},
		//Delete File-CAPABackground Files
		handleRemove1(value) {
			let that = this;
			that.$confirm("Are you sure you want to delete this CAPA background file？", "Prompt", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsCapaBackgroundFileDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							that.getPageInfo();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		//Delete File-Correction File
		handleRemove3(value) {
			let that = this;
			that.$confirm("Are you sure you want to delete this correction file?", "Prompt", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsCapaCorrectionsFileDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							that.getPageInfo();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		//Delete File-Affected Items
		handleRemove2(value) {
			let that = this;
			that.$confirm("Are you sure you want to delete this item?", "Prompt", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsCapaAffectedArticleDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							that.getPageInfo();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		openFileDialog(name) {
			let that = this;
			that.dialogVisibleTitle = name;
			that.dialogVisible = true;
			that.ruleForm = {
				files: '',
				description: "",
				capa_id: "",
			};
			that.fileName = "";
			that.selectedFile = null;
			that.$nextTick(() => {
				if (that.$refs.ruleForm) {
					that.$refs.ruleForm.clearValidate();
				}
				if (that.$refs.uploadBox) {
					that.$refs.uploadBox.clearFiles();
				}
			});
		},
		//Confirm File Upload
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					if (!that.selectedFile) {
						that.$message.warning("Please upload a file");
						return false;
					}
					that.$toast.loading({ duration: 0, forbidClick: true });
					const formData = new FormData();
					//Upload File
					switch(that.dialogVisibleTitle) {
						case 'Add CAPA Background File':
							formData.append('files', that.selectedFile);
							formData.append('description', that.ruleForm.description);
							formData.append('capa_id', that.form.id);
							formData.append('id', '');
							capaUploadsCapaBackgroundFile(formData).then(res => {
								if(res.code == 200) {
									that.$toast.clear();
									that.$message.success('Operation successful');
									setTimeout(() => {
										that.dialogVisible = false;
										//Request Page Details
										that.getPageInfo();
									}, 800);
								}
							});
						break;
						case 'Add Correction File':
							formData.append('files', that.selectedFile);
							formData.append('description', that.ruleForm.description);
							formData.append('capa_id', that.form.id);
							formData.append('id', '');
							capaUploadsCapaCorrectionsFile(formData).then(res => {
								if(res.code == 200) {
									that.$toast.clear();
									that.$message.success('Operation successful');
									setTimeout(() => {
										that.dialogVisible = false;
										//Request Page Details
										that.getPageInfo();
									}, 800);
								}
							});
						break;
					}
				} else {
					return false;
				}
			});
		},
		//Delete File
		delFile() {
			let that = this;
			that.selectedFile = null;
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//Navigate to Page
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}
			}
		}
	}

	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-cert-page {
		padding: 10px;
		background: #fff;
		min-height: 100%;
		box-sizing: border-box;
	}

	.page-title {
		font-size: 18px;
		font-weight: 700;
		color: #303133;
		margin-bottom: 10px;
	}

	.card-block {
		margin-bottom: 12px;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.search-input {
		width: 180px;
	}

	.form-block {
		margin-bottom: 14px;
	}

	.form-label {
		font-size: 14px;
		color: #606266;
		margin-bottom: 6px;
		font-weight: 600;
	}

	.section-title {
		font-size: 16px;
		font-weight: 700;
		color: #303133;
	}

	.file-action-row {
		margin-top: 10px;
		display: flex;
		gap: 10px;
	}

	.footer-actions {
		margin-top: 26px;
		display: flex;
		justify-content: center;
		gap: 12px;
	}

	.file-list-inline {
		margin: 0;
		padding-left: 0px;
	}

	.file-list-inline li {
		line-height: 20px;
	}

	/* 更接近截图的表格视觉 */
	::v-deep .el-table th {
		padding: 10px 0;
	}

	::v-deep .el-table td {
		padding: 10px 0;
	}

	::v-deep .el-table .current-row>td {
		background-color: #eef3ff !important;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}
</style>